<template>
  <div class="user">
    <div id='userIcon' class="photo md-lg" style="overflow: visible; border-radius: 0px; margin: 0 15px 0 18px; padding: 4px 10px;">
      <md-icon>account_circle</md-icon>
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span v-if="$route.meta.rtlActive">
          {{ rtlTitle }}
          <b class="caret"></b>
        </span>
        <span v-else>
          {{ title }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <!-- <li>
                <a v-if="$route.meta.rtlActive" href="#vue">
                  <span class="sidebar-mini">مع</span>
                  <span class="sidebar-normal">ملف</span>
                </a>
                <a v-else href="#vue">
                  <span class="sidebar-mini">MP</span>
                  <span class="sidebar-normal">My Profile</span>
                </a>
              </li>
              <li>
                <a v-if="$route.meta.rtlActive" href="#vue">
                  <span class="sidebar-mini">هوع</span>
                  <span class="sidebar-normal">تعديل الملف الشخصي</span>
                </a>
                <a v-else href="#vue">
                  <span class="sidebar-mini">EP</span>
                  <span class="sidebar-normal">Edit Profile</span>
                </a>
              </li>
              <li>
                <a v-if="$route.meta.rtlActive" href="#vue">
                  <span class="sidebar-mini">و</span>
                  <span class="sidebar-normal">إعدادات</span>
                </a>
                <a v-else href="#vue">
                  <span class="sidebar-mini">S</span>
                  <span class="sidebar-normal">Settings</span>
                </a>
              </li> -->
              <li>
                <a @click="$store.dispatch('auth/logout')">
                  <span class="sidebar-mini">S</span>
                  <span class="sidebar-normal">{{$t('userMenu.toGoOut')}}</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    rtlTitle: {
      type: String,
      default: 'تانيا أندرو'
    },
    avatar: {
      type: String,
      default: './img/avatar.jpg'
    }
  },
  data () {
    return {
      isClosed: true
    }
  },
  computed: {
    title () {
      let currentUrl = window.location.href
      if (!currentUrl.includes('outbound') && !(currentUrl.includes('rocketchat') || currentUrl.includes('rocket.chat'))) {
        let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
        let result = currentUrl.match(titleRegex)[3]
        return (result.charAt(0).toUpperCase() + result.slice(1))
      } else if ((currentUrl.includes('rocketchat') || currentUrl.includes('rocket.chat')
      )) {
        return 'Ipmc'
      }
      return 'Ima'
    }
  },
  methods: {
    clicked: function (e) {
      e.preventDefault()
    },
    toggleMenu: function () {
      this.isClosed = !this.isClosed
    }
  }
}
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
#userIcon > .md-icon.md-theme-default.md-icon-font {
  color: #fff !important;
}
</style>
